import URI from 'urijs'
import {DateFormat} from '../date_format'
import {EnterTT} from '../constants'

export function makeEnterTTUrl(date, userId) {
    const url = URI(EnterTT.PAGE_URL)
    if (EnterTT.IS_NEXT) {
        date && url.addSearch("date", new DateFormat("yyyy-MM-dd").formatDate(date))
        userId && url.addSearch("cuser", userId)
    } else {
        date && url.addSearch("dateStr", new DateFormat("yyyy MM dd").formatDate(date).replace(/\s+/g, ''))
        userId && url.addSearch("usersSelector.selectedUser", userId)
    }
    return url.toString()
}

export default {
    makeEnterTTUrl
}



// WEBPACK FOOTER //
// ./web/js/util/EnterTTUrlUtils.js